
import moment from 'moment';
import momentTZ from 'moment-timezone';


export const formattedDate = (date, format) => {
  return moment.utc(date).format(format);
};

export const addTime = (date, amount, unit) => {
  return moment(date).add(amount, unit).toISOString();
};

export const isToday = (date) => {
  return moment(date).isSame(moment(), 'day');
};

export const toNow = (date) => {
  return moment(date).toNow(true);
};
export const fromNow = (date) => {
  return moment(date).fromNow(true);
};

export const isBeforeNow = (date) => {
  return moment(date).isBefore(moment().utc());
};
export const isAfterNow = (date) => {
  return moment(date).isAfter(moment().utc());
};

export const isValidISO8601String = (date) => {
  return moment(date, moment.ISO_8601).isValid();
};

export const isoString = () => {
  return moment().toISOString();
};

export const unixToISOSting = (t) => {
  return moment(t).toISOString();
};

export const getTimeZones = () => {
  return momentTZ.tz.names();
};